import { FC } from 'react';
import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { mapSharedPropertiesToFields } from '@gn-audio/jss-core';

import { usePathMatch } from '../../utils/hooks/usePathMatch';

export type WarningMessageRendering = {
  fields: WarningMessageFields;
};
export type WarningMessageFields = {
  message?: Field<string>;
  whitelistPaths?: Field<string>;
  isActive?: Field<boolean>;
};
export type WarningMessageProps = {
  rendering: WarningMessageRendering & ComponentRendering;
};

export const WarningMessage: FC<WarningMessageProps> = ({ rendering }) => {
  const { isCurrentPathMatched } = usePathMatch();
  const data = mapSharedPropertiesToFields<WarningMessageFields>(
    rendering.fields as WarningMessageFields
  );

  const isOnWhiteList = isCurrentPathMatched(data.whitelistPaths?.value);
  const showWarning = isOnWhiteList && data?.isActive?.value;

  if (!showWarning) return null;

  if (!data?.message?.value) return null;
  const cleanHTMLMessage = sanitize(data.message.value);
  return (
    <div className="bg-primary">
      <div
        className="container py-1 text-center"
        dangerouslySetInnerHTML={{ __html: cleanHTMLMessage }}
      />
    </div>
  );
};
